import { defaultPermissions } from "routes/enum";

export const getRolePermissions = (role) => {
    const systemPermissions = role?.systemPermissions ?? [];
    const customPermissions = role?.permissions ?? [];

    return [...systemPermissions, ...customPermissions];
};

export const getRolePermissionCodes = (role) =>
    getRolePermissions(role)
        .map((permission) => permission?.permissionCode)
        .filter(Boolean);

export const getRolePermissionCategories = (role) => {
    const categories = new Set();

    getRolePermissions(role).forEach((permission) => {
        if (permission?.groupDisplayName) {
            categories.add(permission.groupDisplayName);
            return;
        }

        if (permission?.displayName) {
            categories.add("Custom Permissions");
        }
    });

    return [...categories].sort((a, b) => a.localeCompare(b));
};

export const roleHasPermission = (role, requiredCodes = []) => {
    if (!requiredCodes?.length) {
        return true;
    }

    const grantedCodes = new Set(getRolePermissionCodes(role));

    return [...requiredCodes, ...defaultPermissions].some((code) =>
        grantedCodes.has(code)
    );
};

export const mapStateToRolePermissions = (state) => ({
    permissions: getRolePermissions(state?.auth?.user?.role),
});
